(function(){
var FORMATS={digital:{name:'eBook',price:'$19.99',note:'PDF arrives in your inbox right after checkout'},
  digital_app:{name:'eBook + Build Buddy app',price:'$29.99',note:'PDF and app login in your inbox right after checkout'},
  bundle:{name:'eBook + Printed Book',price:'$39.99',note:'Printed books ship in 5–8 business days · PDF arrives right away'},
  complete:{name:'The Complete Workshop',price:'$49.99',note:'Book ships in 5–8 business days · PDF and app arrive right away'}};
var current='complete';

// [name, category, difficulty 1-3, hours, wood $, extra tool ('' | 'pocket' | 'brad'), typical store price $, popular]
var PROJECTS=[
['Classic Cedar Planter Box 12×12','planters',1,2,14,'',45],
['Long Deck Planter 48"','planters',1,3,22,'',89],
['Six-Foot Fence Planter','planters',2,4,38,'',149],
['Tall Tapered Planter','planters',2,3,20,'',79],
['Pair of Conical Planters','planters',2,3,26,'',119],
['Window Box 36"','planters',1,2,16,'',59],
['Window Box 48"','planters',1,2,19,'',69],
['Trellis Planter','planters',2,4,34,'',139],
['V-Trellis Planter','planters',2,4,36,'',149],
['XXL Trellis Planter','planters',3,6,62,'',249],
['Privacy Screen Planter','planters',2,5,58,'',229],
['Large Privacy Planter Wall','planters',3,6,84,'',329],
['Raised Garden Bed 4×2','planters',1,3,40,'',129],
['L-Shaped Raised Bed','planters',2,5,70,'',229],
['Raised Bed with Shelf','planters',2,5,56,'',199,1],
['Waist-High Planter Table','planters',2,5,60,'',219],
['3-Tier Sloped Herb Planter','planters',2,4,32,'',119],
['6-Tier Herb Garden Tower','planters',2,4,36,'',139],
['Wishing Well Planter','planters',3,6,45,'',189],
['Windmill Planter','planters',3,6,42,'',179],
['Welcome Sign Planter','planters',1,3,24,'',89],
['Planter with Garden Sign','planters',1,3,22,'',79],
['Window-Frame Planter','planters',2,4,30,'',119],
['Hanging Basket Stand','planters',1,2,18,'',69],
['Planter with Tomato Cage','planters',2,3,28,'',99],
['Corner Planter','planters',2,3,24,'',89],
['Square Patio Planter 24"','planters',1,3,30,'',119,1],
['Fence-Post Planter','planters',1,3,26,'',99,1],
['Strawberry Planter','planters',2,3,26,'',99],
['Hose Holder Planter','planters',2,3,26,'',89],
['Railing Planter','planters',1,2,15,'',49],
['Succulent Box','planters',1,1,8,'',29],
['Potting Bench / Garden Station','planters',2,6,90,'',299,1],
['Compost Bin with Lid','planters',2,4,55,'',179],
['Adirondack Chair','seating',2,5,45,'',279,1],
['Adirondack Loveseat','seating',3,7,80,'',449],
['Adirondack Footrest','seating',1,2,18,'',89],
['Two-Seat Bench with Center Table','seating',2,6,70,'',399,1],
['Two-Seat Bench with Cooler Box','seating',3,7,85,'',449],
['Two-Seat Porch Swing','seating',3,8,95,'',399],
['Porch Swing with Storage Table','seating',3,9,110,'',499],
['Simple Garden Bench','seating',1,3,30,'',149,1],
['Backless Patio Bench','seating',1,2,25,'',119],
['L-Shaped Planter Bench','seating',3,8,120,'',549],
['Folding Garden Chair','seating',2,4,32,'',149,1],
['Viking Campfire Chair','seating',2,3,28,'',129],
['Throne Fire-Pit Chair','seating',2,4,38,'',179],
['Patio Sectional: Corner Seat','seating',3,8,140,'',599],
['Patio Sectional: Middle Seat','seating',2,5,85,'',399],
['Garden Bench with Arbor','seating',3,9,150,'',649],
['Bar Stools (set of 2)','seating',2,4,40,'pocket',179],
['Farmhouse Dining Chair','seating',3,5,45,'pocket',189],
['Picnic Table for Two','tables',2,4,48,'',229],
['Kids\' Picnic Table','tables',1,3,35,'',129],
['Cedar Patio Coffee Table','tables',1,3,32,'',179],
['Round Rustic Side Table','tables',2,3,24,'',119],
['Outdoor Side Table','tables',1,2,18,'',89],
['4-Seat Pub Table','tables',2,5,65,'',329,1],
['Outdoor Bar Table','tables',2,5,70,'',349],
['Drink Rail Stand','tables',1,3,30,'',129],
['Patio Dining Table (seats 6)','tables',3,8,140,'',699],
['Cooler Cart Table','tables',2,5,75,'',299],
['Folding Camp Table','tables',2,3,28,'',119],
['Outdoor Serving Cart','tables',2,5,68,'',279],
['A-Frame Firewood Rack','yard',1,3,40,'',149],
['Half-Cord Firewood Shed','yard',3,8,160,'',549],
['Classic Birdhouse','yard',1,1,6,'',35],
['Picket-Fence Birdhouse','yard',1,2,9,'',45],
['Birdhouse with Planters','yard',2,3,20,'',89],
['Squirrel Picnic-Table Feeder','yard',1,1,5,'',29],
['Platform Bird Feeder','yard',1,2,10,'',49],
['Decorative Garden Windmill','yard',3,7,55,'',249],
['Garden Arbor','yard',3,8,130,'',499],
['Trash Can Screen','yard',2,5,75,'',299],
['Garden Tool Rack','yard',1,2,22,'',79],
['Mailbox Post Planter','yard',2,4,45,'',179],
['Farmhouse Coffee Table','indoor',2,5,60,'pocket',349],
['Farmhouse End Table','indoor',2,4,40,'pocket',199],
['Rustic Nightstand with Drawer','indoor',3,6,45,'pocket',229],
['Open Rustic Nightstand','indoor',2,4,32,'',149],
['Entryway Bench with Shoe Shelf','indoor',2,4,40,'brad',199],
['Fold-Down Loft Ladder','indoor',2,5,60,'',249],
['Floating Shelves (set of 3)','indoor',1,2,18,'',79],
['Blanket Ladder','indoor',1,2,15,'',69],
['Wine Rack','indoor',2,3,25,'brad',99],
['Fold-Down Wall Table','indoor',2,4,40,'',199],
['Regulation Cornhole Boards','games',2,6,70,'',199],
['Hook & Ring Toss','games',1,2,14,'',49],
['Giant Tumble Tower','games',1,4,38,'',129],
['Lift-Top Coffee Table','indoor',2,6,70,'',299,1],
['Convertible Bench / Picnic Table','tables',2,6,62,'',349,1],
['Kids\' Sandbox with Seats','games',2,5,55,'',229],
['Rustic Christmas Sleigh','holiday',2,4,30,'',149],
['Porch Christmas Tree','holiday',1,2,15,'',79],
['Reindeer Pair','holiday',2,3,20,'brad',119],
['Fold-Out Console Dining Table','indoor',3,7,85,'',399,1],
['Storage Bench with Lid','indoor',2,5,55,'',249,1],
['Armchair Guest Bed','indoor',3,8,120,'',549,1],
['Folding Step Stool','indoor',1,3,18,'',79],
['Daybed with Trundle','indoor',3,9,160,'',699]
];
var CATS=[['all','All'],['planters','Planters & Raised Beds'],['seating','Outdoor Seating'],['tables','Tables'],['yard','Garden & Yard'],['indoor','Indoor Farmhouse'],['games','Games & Fun'],['holiday','Holiday & Gifts']];
var TOOLNAME={pocket:'Pocket hole jig',brad:'Brad nailer'};
function $(s,r){return (r||document).querySelector(s)}
function $$(s,r){return [].slice.call((r||document).querySelectorAll(s))}
function dots(n){return '●●●'.slice(0,n)+'<span style="opacity:.25">'+'●●●'.slice(n)+'</span>'}
function esc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;')}

// facts from data
var basic=PROJECTS.filter(function(p){return !p[5]}).length;
var under=PROJECTS.filter(function(p){return p[4]<60}).length;
$('#factBasic').textContent=basic;$('#basicCount2').textContent=basic;$('#factUnder').textContent=under;

// image placeholders
$$('.ph').forEach(function(f){var img=f.querySelector('img');if(!img)return;
  function ok(){f.classList.add('ok');f.classList.remove('noimg')}
  function bad(){f.classList.add('noimg');f.classList.remove('zoom')}
  if(img.complete){img.naturalWidth?ok():bad()}else{img.addEventListener('load',ok);img.addEventListener('error',bad)}});

// format selector (all groups stay in sync)
function setFormat(f){current=f;
  $$('.fmt').forEach(function(b){var on=b.dataset.fmt===f;b.classList.toggle('on',on);b.setAttribute('aria-checked',on)});
  $$('.buy:not([data-lock])').forEach(function(b){b.dataset.variant=f});
  $('#stickyPrice').textContent=FORMATS[f].price;$('#stickyName').textContent=FORMATS[f].name;
  $('#offerNote').textContent=FORMATS[f].note;}
$$('.fmt').forEach(function(b){b.addEventListener('click',function(){setFormat(b.dataset.fmt)})});

// miniature dell'immagine principale
var hf=document.getElementById('heroFig'),hi=document.getElementById('heroImg');
$$('#heroThumbs button').forEach(function(b){b.addEventListener('click',function(){
  $$('#heroThumbs button').forEach(function(x){x.classList.toggle('on',x===b)});
  var t=b.querySelector('img'), r=t.naturalWidth&&t.naturalHeight?t.naturalWidth/t.naturalHeight:4/3;
  hi.src=t.src;
  // più larga di 4:3 → il riquadro prende la sua forma; più alta → resta 4:3 e la foto si vede intera
  if(r>=4/3){hf.style.aspectRatio=String(r);hi.style.objectFit='cover';hf.classList.remove('tallimg')}
  else{hf.style.aspectRatio='4/3';hi.style.objectFit='contain';hf.classList.add('tallimg')}})});

// frecce del carosello pagine
$$('.pagenav button').forEach(function(b){b.addEventListener('click',function(){var r=$('#pagerow');r.scrollBy({left:(+b.dataset.dir)*r.clientWidth*0.8,behavior:'smooth'})})});

// recensioni: esempio solo in anteprima (?demo=1)
if(/[?&]demo=1/.test(location.search)){$('#revDemo').hidden=false;$('#revLive').hidden=true}
// conto alla rovescia di Natale vicino al pulsante
(function(){var end=new Date('2026-12-11T04:59:00Z').getTime();function t(){var s=(end-Date.now())/1000;var el=$('#xmasLine');if(!el)return;
  if(s<=0){el.style.display='none';return}var d=Math.floor(s/86400),h=Math.floor(s%86400/3600);$('#xmasLeft').textContent=d+' days '+h+' h'}t();setInterval(t,60000)})();

// buy buttons → event for the shop integration
document.addEventListener('click',function(e){var b=e.target.closest('.buy');if(!b)return;e.preventDefault();
  document.dispatchEvent(new CustomEvent('picket:buy',{detail:{variant:b.dataset.variant||current}}));});

// explorer
var cat='all',full=false;
var fwrap=$('#filters');
CATS.forEach(function(c){var n=c[0]==='all'?PROJECTS.length:PROJECTS.filter(function(p){return p[1]===c[0]}).length;
  var b=document.createElement('button');b.className='fchip'+(c[0]==='all'?' on':'');b.type='button';b.dataset.c=c[0];
  b.innerHTML=esc(c[1])+'<small>'+n+'</small>';fwrap.appendChild(b)});
fwrap.addEventListener('click',function(e){var b=e.target.closest('.fchip');if(!b)return;cat=b.dataset.c;
  $$('.fchip').forEach(function(x){x.classList.toggle('on',x===b)});render()});
['#psearch','#pbasic','#peasy'].forEach(function(s){$(s).addEventListener('input',render)});
$('#pmore2').addEventListener('click',function(){full=true;render();$('#pwrap').scrollIntoView({behavior:'smooth',block:'start'})});
var IMGB=window.PK_IMG_BASE||'img/';
var PHOTO={"Adirondack Chair":"adirondack-chair","Two-Seat Bench with Center Table":"two-seat-bench-center-v2","Fold-Out Console Dining Table":"fold-out-console-dining-tabl","Regulation Cornhole Boards":"regulation-cornhole-boards","Lift-Top Coffee Table":"lift-top-coffee-table","Potting Bench / Garden Station":"potting-bench-garden-station","Privacy Screen Planter":"privacy-screen-planter","Raised Bed with Shelf":"raised-bed-with-shelf","Two-Seat Porch Swing":"two-seat-porch-swing","Folding Garden Chair":"folding-garden-chair","Convertible Bench / Picnic Table":"convertible-bench-picnic-tab","Storage Bench with Lid":"storage-bench-with-lid","Fold-Down Wall Table":"fold-down-wall-table","Folding Step Stool":"folding-step-stool","Armchair Guest Bed":"armchair-guest-bed","Daybed with Trundle":"daybed-with-trundle","Fold-Down Loft Ladder":"fold-down-loft-ladder","Classic Cedar Planter Box 12×12":"classic-cedar-planter-box-12","Window Box 36\"":"window-box-36","Trellis Planter":"trellis-planter","3-Tier Sloped Herb Planter":"3-tier-sloped-herb-planter","4-Seat Pub Table":"4-seat-pub-table","Kids' Picnic Table":"kids-picnic-table","A-Frame Firewood Rack":"a-frame-firewood-rack","Garden Arbor":"garden-arbor","Picket-Fence Birdhouse":"picket-fence-birdhouse","Giant Tumble Tower":"giant-tumble-tower","Rustic Christmas Sleigh":"rustic-christmas-sleigh","Farmhouse Coffee Table":"farmhouse-coffee-table"};
var BIG={"classic-cedar-planter-box-12":1,"window-box-36":1,"trellis-planter":1,"3-tier-sloped-herb-planter":1,"4-seat-pub-table":1,"kids-picnic-table":1,"a-frame-firewood-rack":1,"garden-arbor":1,"picket-fence-birdhouse":1,"giant-tumble-tower":1,"rustic-christmas-sleigh":1,"farmhouse-coffee-table":1};
// le prime foto mostrate da chiuso: una per tipo, per far vedere la varietà
var TEASE=['Adirondack Chair','4-Seat Pub Table','Two-Seat Porch Swing','Raised Bed with Shelf','Farmhouse Coffee Table','Garden Arbor','Giant Tumble Tower','Rustic Christmas Sleigh','Convertible Bench / Picnic Table','Window Box 36"','Lift-Top Coffee Table','Picket-Fence Birdhouse'];
function tz(n){var k=TEASE.indexOf(n);return k<0?99:k}
function card(p,i){var cname=CATS.filter(function(c){return c[0]===p[1]})[0][1],ph=PHOTO[p[0]],img;
  if(ph){var big=IMGB+(BIG[ph]?'pk-p2-':'pk-c-')+ph+'.webp';
    img='<div class="pimg photo" data-big="'+big+'"><img src="'+IMGB+'pk-c-'+ph+'.webp" alt="'+esc(p[0])+', built from cedar pickets" loading="lazy">'+(p[7]?'<span class="pop">★ Reader favorite</span>':'')+'</div>'}
  else img='<div class="pimg lock"><img src="'+IMGB+'pk-blur'+(i%12)+'.webp" alt="" loading="lazy"><span class="lk">🔒 Full plan inside</span></div>';
  return '<div class="ptile">'+img+'<div class="pb"><span class="no">#'+String(i+1).padStart(3,'0')+' · '+esc(cname)+'</span><span class="t">'+esc(p[0])+'</span><div class="meta"><span class="diff" title="Difficulty '+p[2]+' of 3">'+dots(p[2])+'</span><span>~'+p[3]+' h</span><span>~$'+p[4]+' wood</span>'+(p[5]?'<span class="x">+ '+TOOLNAME[p[5]]+'</span>':'')+'</div></div></div>'}
function render(){var q=$('#psearch').value.trim().toLowerCase(),b=$('#pbasic').checked,ez=$('#peasy').checked,list=[];
  PROJECTS.forEach(function(p,i){if(cat!=='all'&&p[1]!==cat)return;if(b&&p[5])return;if(ez&&p[2]!==1)return;if(q&&p[0].toLowerCase().indexOf(q)<0)return;list.push([p,i])});
  // prima quelli con la foto, poi gli altri nell'ordine del libro
  list.sort(function(a,c){return (PHOTO[c[0][0]]?1:0)-(PHOTO[a[0][0]]?1:0)||a[1]-c[1]});
  var clip=!full&&list.length>12,show=list;
  // chiuso: 8 foto e sotto 4 progetti "sfocati" che sfumano, per far vedere che ce ne sono molti altri
  if(clip){var ph=list.filter(function(x){return PHOTO[x[0][0]]}).sort(function(x,y){return tz(x[0][0])-tz(y[0][0])}),lk=list.filter(function(x){return !PHOTO[x[0][0]]});
    show=ph.slice(0,8);show=show.concat(lk.slice(0,12-show.length));if(show.length<12)show=list.slice(0,12)}
  $('#plist').innerHTML=show.map(function(x){return card(x[0],x[1])}).join('')||'<p class="muted">No project matches. Try another word.</p>';
  $('#pcount').textContent=list.length;
  $('#pwrap').classList.toggle('clip',clip);
  $('#pmore2').textContent=cat==='all'&&!q?'See all 100 projects':'See all '+list.length+' projects'}
document.addEventListener('click',function(e){var t=e.target.closest('.pimg.photo');if(!t)return;$('img',lb).src=t.dataset.big;lb.classList.add('on')});
render();

// calculator
var sel=$('#calcSel');
PROJECTS.forEach(function(p,i){if(p[6]>=99){var o=document.createElement('option');o.value=i;o.textContent=p[0];sel.appendChild(o)}});
sel.value=String(PROJECTS.findIndex(function(p){return p[0]==='Adirondack Chair'}));
function calc(){var p=PROJECTS[+sel.value];$('#cStore').textContent='$'+p[6];$('#cWood').textContent='$'+p[4];$('#cTime').textContent='~'+p[3]+' h';$('#cSave').textContent='$'+(p[6]-p[4])}
sel.addEventListener('change',calc);calc();

// finder
var ans={};
$$('.fq').forEach(function(q){q.addEventListener('click',function(e){var b=e.target.closest('.opt');if(!b)return;
  $$('.opt',q).forEach(function(x){x.classList.toggle('on',x===b)});ans[q.dataset.q]=b.dataset.v;finder()})});
function finder(){if(!ans.goal||!ans.tools||!ans.time)return;
  var goalCats={planters:['planters'],seating:['seating'],tables:['tables'],gift:['holiday','games','yard']}[ans.goal];
  var max=+ans.time;
  var pool=PROJECTS.map(function(p,i){return {p:p,i:i}}).filter(function(o){var p=o.p;
    return goalCats.indexOf(p[1])>=0&&(ans.tools==='more'||!p[5])&&p[3]<=max});
  pool.sort(function(a,b){return (b.p[7]?1:0)-(a.p[7]?1:0)||a.p[2]-b.p[2]||b.p[6]-a.p[6]});
  var picks=pool.slice(0,3);
  if(picks.length<3){PROJECTS.forEach(function(p,i){if(picks.length<3&&goalCats.indexOf(p[1])>=0&&!picks.some(function(x){return x.i===i})&&(ans.tools==='more'||!p[5]))picks.push({p:p,i:i})})}
  $('#fpicks').innerHTML=picks.map(function(o){return card(o.p,o.i)}).join('');
  $('#fres').classList.add('show')}

// Christmas countdown (Dec 10, 2026, 23:59 ET)
var end=new Date('2026-12-11T04:59:00Z').getTime();
function tick(){var s=Math.max(0,end-Date.now())/1000;
  if(s<=0){$('#cd').style.display='none';$('#cdNote').textContent='Christmas delivery for the printed book has closed: the digital edition and the gift certificate still arrive right away.';return}
  $('#cdD').textContent=Math.floor(s/86400);$('#cdH').textContent=Math.floor(s%86400/3600);$('#cdM').textContent=Math.floor(s%3600/60)}
tick();setInterval(tick,30000);

// faq: one open at a time
$$('#faqList details').forEach(function(d){d.addEventListener('toggle',function(){if(d.open)$$('#faqList details').forEach(function(o){if(o!==d)o.open=false})})});

// sticky bar after the hero buy box
var sticky=$('#sticky'),box=$('#buybox'),offer=$('#offer');
function onScroll(){var r=box.getBoundingClientRect(),o=offer.getBoundingClientRect();
  sticky.classList.toggle('on',r.bottom<0&&!(o.top<innerHeight&&o.bottom>0))}
addEventListener('scroll',onScroll,{passive:true});onScroll();

// lightbox
var lb=$('#lb');
var lbList=null,lbI=0;
lb.insertAdjacentHTML('beforeend','<button type="button" class="lbn p" aria-label="Previous page">‹</button><button type="button" class="lbn n" aria-label="Next page">›</button><span class="lbc"></span>');
function lbShow(){var im=lbList[lbI].querySelector('img');$('img',lb).src=im.src;$('.lbc',lb).textContent=(lbI+1)+' / '+lbList.length}
function lbNav(on){$$('.lbn,.lbc',lb).forEach(function(x){x.style.display=on?'':'none'})}
document.addEventListener('click',function(e){var f=e.target.closest('.ph.zoom.ok');if(!f)return;
  if(f.closest('#pagerow')){lbList=$$('#pagerow figure').filter(function(x){return x.style.display!=='none'});lbI=lbList.indexOf(f);lbShow();lbNav(true)}
  else{lbList=null;$('img',lb).src=f.querySelector('img').src;lbNav(false)}
  lb.classList.add('on')});
lb.addEventListener('click',function(e){var n=e.target.closest('.lbn');if(n&&lbList){lbI=(lbI+(n.classList.contains('n')?1:-1)+lbList.length)%lbList.length;lbShow();return}lb.classList.remove('on')});
addEventListener('keydown',function(e){if(!lb.classList.contains('on'))return;if(e.key==='Escape')lb.classList.remove('on');
  if(lbList&&(e.key==='ArrowRight'||e.key==='ArrowLeft')){lbI=(lbI+(e.key==='ArrowRight'?1:-1)+lbList.length)%lbList.length;lbShow()}});
// filtri delle pagine
$$('#pchips button').forEach(function(b){b.addEventListener('click',function(){var k=b.dataset.k;
  $$('#pchips button').forEach(function(x){x.classList.toggle('on',x===b)});
  $$('#pagerow figure').forEach(function(f){f.style.display=(k==='all'||f.dataset.k===k)?'':'none'});$('#pagerow').scrollLeft=0})});

// reveal on scroll
if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})},{rootMargin:'0px 0px -8% 0px'});
  $$('.rv').forEach(function(el){io.observe(el)})}else{$$('.rv').forEach(function(el){el.classList.add('in')})}
})();
// acquisto: variante scelta -> form Shopify -> carrello
document.addEventListener('picket:buy',function(e){var v=(window.PK_VARIANTS||{})[e.detail.variant];var f=document.getElementById('pk-atc');if(!f||!v)return;f.querySelector('[name=id]').value=v;f.submit();});
